import { useGetInstitutionQuery } from "../../store/api/generated/stock-request-api";
import { isNullish } from "../../lib/util/common-util";
import { useMemo } from "react";
import {
  institutionMeta,
  InstitutionSaved,
} from "../../lib/object/entity/institution";

export function useAppGetInstitutionQuery(
  arg: Parameters<typeof useGetInstitutionQuery>[0],
  options?: Parameters<typeof useGetInstitutionQuery>[1],
  skipOptionalValidations = true, // get系は、skipOptionalValidationsのデフォルトはtrueとする。
): {
  data: InstitutionSaved | null;
  refetch: ReturnType<typeof useGetInstitutionQuery>["refetch"];
  error: ReturnType<typeof useGetInstitutionQuery>["error"];
} {
  const {
    data: rawData,
    refetch,
    error,
  } = useGetInstitutionQuery(arg, options);
  const data = useMemo(() => {
    if (isNullish(rawData)) return null;
    return institutionMeta.toSavedDomainObjectOrNull(
      rawData,
      skipOptionalValidations,
    );
  }, [rawData, skipOptionalValidations]);
  return { data, refetch, error };
}
